import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import { LS_JWT_KEY } from '~/const/api'
import { Route } from '~/routes/subscription/checkout/complete'
import { useAccountStore } from '~/stores/account'

export const useSubmitCheckoutComplete = () => {
  const { session_id, redirectTo } = Route.useSearch()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const patchAccount = useAccountStore(state => state.patchAccount)

  useEffect(() => {
    if (!session_id) return

    const confirmPaymentOnApi = async () => {
      try {
        const { data } = await apiClient.GET('/subscription/checkout/complete', {
          params: {
            query: {
              session_id,
            },
          },
        })

        if (!data?.jwtToken) return navigate({ to: '/subscription', search: { error: t('Something went wrong') } })

        localStorage.setItem(LS_JWT_KEY, data.jwtToken)
        patchAccount({ coins: data.coins, planId: data.planId, planCoins: data.coins })

        return navigate({ to: redirectTo ?? '/list' })
      } catch (error) {
        toast.error(t('Network error'))
        console.error({ message: 'Network error', error })

        return navigate({ to: '/subscription', search: { error: t('Something went wrong') } })
      }
    }

    void confirmPaymentOnApi()
  }, [navigate, patchAccount, redirectTo, session_id, t])
}
